export const environment = {
    production: false,
    version: '1.0',
    apiUrl: 'https://api.iterp.dev.itvalues.site',
    logo: ''
};